export const NUMBER_OF_Y_TICKS = 5;
export const POINT_SIZE = 8;
export const MOBILE_POINT_SIZE = 3;

export const POINT_COLOR = '#ffffff';
export const POINT_BORDER_WIDTH = 3;
export const MOBILE_POINT_BORDER_WIDTH = 1;

export const X_TICK_MIN_WIDTH = 60;

export const MIN_NUMBER_OF_TICKS = 2;

export const CHART_MARGIN = {
  top: 20,
  right: 20,
  bottom: 40,
  left: 40,
};

export const THEME = {
  background: 'transparent',
  text: {
    fill: '#6b6b6b',
    fontSize: 14,
  },
  axis: {
    domain: {
      line: {
        stroke: '#dedede',
        strokeWidth: 1,
      },
    },
  },
  grid: {
    line: {
      stroke: '#dedede',
      strokeWidth: 1,
      strokeDasharray: '4 4',
    },
  },
  crosshair: {
    line: {
      stroke: '#dedede',
      strokeWidth: 2,
    },
  },
};
